module.exports = require('./helpers/bundle-url').getBundleURL('3x3zo') + "logo.c51670a8.svg";